module.exports = __webpack_public_path__ + "static/img/company_bg.cc93be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company_bg.png
// module id = 914g
// module chunks = 12